import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Enterprise4SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M10.924 14.904a6.522 6.522 0 0 0 3.67-3.447 29.17 29.17 0 0 1-2.69.346c-.214 1.208-.553 2.27-.98 3.1ZM8.656 16.81a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.484-1.518a6.613 6.613 0 0 1-.967 0l-.01-.01c-.265-.256-.561-.687-.836-1.317a10.262 10.262 0 0 1-.63-2.078 40.24 40.24 0 0 0 3.918 0 10.257 10.257 0 0 1-.63 2.078c-.275.63-.57 1.061-.835 1.317l-.01.01Zm2.935-4.76a25.535 25.535 0 0 0 2.954-.434 6.53 6.53 0 0 0 0-2.577 25.54 25.54 0 0 0-2.954-.434 18.106 18.106 0 0 1 0 3.445Zm-1.266-3.538c.063.575.097 1.184.097 1.816 0 .632-.034 1.24-.097 1.816a38.691 38.691 0 0 1-4.305 0 16.68 16.68 0 0 1-.098-1.816c0-.632.035-1.24.098-1.816a38.728 38.728 0 0 1 4.305 0Zm1.094-1.177a29.21 29.21 0 0 1 2.692.346 6.522 6.522 0 0 0-3.67-3.447c.426.831.765 1.893.978 3.101ZM9.14 2.328l.01.01c.265.256.56.687.836 1.317.254.581.47 1.284.63 2.078a40.224 40.224 0 0 0-3.919 0c.159-.794.375-1.497.63-2.078.275-.63.57-1.06.836-1.317l.01-.01a6.59 6.59 0 0 1 .967 0Zm-2.752.39a6.521 6.521 0 0 0-3.67 3.446c.82-.148 1.724-.265 2.691-.346.214-1.208.552-2.27.98-3.1Zm-1.15 4.37c-1.095.102-2.093.25-2.954.434a6.531 6.531 0 0 0 0 2.577c.86.184 1.859.332 2.954.434a18.052 18.052 0 0 1 0-3.445Zm.171 4.715a29.17 29.17 0 0 1-2.691-.346 6.522 6.522 0 0 0 3.67 3.447c-.427-.831-.765-1.893-.979-3.101Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Enterprise4SVG;
